import Vue from "vue";
import Fuse from "fuse.js";

export default {
  data() {
    return {
      fromStation: {},
      toStation: {},
      fromStationFilterInput: "",
      toStationFilterInput: "",
      filteredFromStations: null,
      filteredToStations: null,
      stations: [],
      toStations: [],
      seferType: 1,
      currentLocationStation: null,
      citiesMap: {},
    };
  },
  methods: {
    formatSubmitDisabled() {
      $(".dropdown-menu form").submit(false);
    },
    swapRouteSefer() {
      if (Object.keys(this.toStation).length !== 0) {
        const tempFromStation = this.fromStation;
        const tempToStation = this.toStation;

        this.fromStation = tempToStation;
        this.toStation = tempFromStation;

        let tempFromStationFilterInput = this.fromStationFilterInput;
        this.fromStationFilterInput = this.toStationFilterInput;
        this.toStationFilterInput = tempFromStationFilterInput;

        if (this.fromStation.id) {
          this.selectStation(this.fromStation.id, "from");
        }
      }
    },
    reloadFilteredFromStations(event) {
      // nereden
      const options = {
        isCaseSensitive: false,
        shouldSort: true,
        findAllMatches: true,
        minMatchCharLength: 1,
        threshold: 0.3,
        keys: ["nameViewer"],
      };
      let fromStationFilterInput = event.target.value;
      let filteredStations = this.stations;

      if (this.citiesMap && Object.keys(this.citiesMap).length > 0) {
        filteredStations.forEach((station) => {
          if (station.name && this.citiesMap[station.areaCode]) {
            station.nameViewer = station.name + " , " + this.citiesMap[station.areaCode].name;
          } else {
            station.nameViewer = station.name;
          }
        });
      }

      if (fromStationFilterInput.length === 0) {
        this.toStationFilterInput = "";
        Vue.set(this, "fromStation", {});
        Vue.set(this, "toStation", {});
      }

      let fuse = new Fuse(filteredStations, options);

      let fromStationResults = [];
      if (fromStationFilterInput.length === 0) {
        fromStationResults = filteredStations.slice();
      } else {
        let fromFuseResult = [];
        if (fromStationFilterInput.startsWith("ist") || fromStationFilterInput.startsWith("Ist") || fromStationFilterInput.startsWith("İst")) {
          fromFuseResult = fuse.search("istanbul");
        } else {
          fromFuseResult = fuse.search(fromStationFilterInput);
        }

        fromFuseResult.forEach((fuseResult) => {
          fromStationResults.push(fuseResult.item);
        });
      }
      Vue.set(this, "filteredFromStations", fromStationResults);
    },
    reloadFilteredToStations(event) {
      // nereye
      const options = {
        isCaseSensitive: false,
        shouldSort: true,
        findAllMatches: true,
        minMatchCharLength: 1,
        threshold: 0.3,
        keys: ["nameViewer"],
      };
      let toStationFilterInput = event.target.value;

      let fuseToStations = new Fuse(this.toStations, options);
      let fuse = new Fuse(this.stations, options);
      if (this.citiesMap && Object.keys(this.citiesMap).length > 0) {
        this.stations.forEach((station) => {
          if (station.name && this.citiesMap[station.areaCode]) {
            station.nameViewer = station.name + " , " + this.citiesMap[station.areaCode].name;
          } else {
            station.nameViewer = station.name;
          }
        });
        this.toStations.forEach((station) => {
          if (station.name && this.citiesMap[station.areaCode]) {
            station.nameViewer = station.name + " , " + this.citiesMap[station.areaCode].name;
          } else {
            station.nameViewer = station.name;
          }
        });
      }

      let toStationResults = [];
      if (toStationFilterInput.length === 0) {
        this.toStations.forEach((station) => {
          toStationResults.push(station);
        });
      } else {
        let toFuseResult = [];
        if (Object.keys(this.fromStation).length === 0) {
          toFuseResult = fuse.search(toStationFilterInput);
        } else {
          toFuseResult = fuseToStations.search(toStationFilterInput);
        }
        toFuseResult.forEach((fuseResult) => {
          toStationResults.push(fuseResult.item);
        });
      }
      Vue.set(this, "filteredToStations", toStationResults);
    },
    openDepartureDropDownMenuOnKeyDown() {
      if (this.$refs.fromToInputs && this.$refs.fromToInputs.$el) {
        const fromDropdownMenu = this.$refs.fromToInputs.$el.querySelector(".searchDropdown .dropdown-menu");
        if (fromDropdownMenu) {
          const isDropdownOpen = $(fromDropdownMenu).hasClass("show");
          if (!isDropdownOpen) {
            // Dropdown açık değilse
            const dropdownInput = this.$refs.fromToInputs.$el.querySelector(".searchDropdown .dropdown-toggle");
            if (dropdownInput) {
              dropdownInput.click();
            }
          }
        }
      } else if (this.$refs.formTrainInformation) {
        const fromDropdownMenu = this.$refs.formTrainInformation.$el.querySelector(".searchDropdown .dropdown-menu");
        if (fromDropdownMenu) {
          const isDropdownOpen = $(fromDropdownMenu).hasClass("show");
          if (!isDropdownOpen) {
            // Dropdown açık değilse
            const dropdownInput = this.$refs.formTrainInformation.$el.querySelector(".searchDropdown .dropdown-toggle");
            if (dropdownInput) {
              dropdownInput.click();
            }
          }
        }
      }
    },
    openRentalCarDropDownMenuOnKeyDown() {
      if (!$("#toWhereDropdownMenu").hasClass("show")) {
        $("#toWhereDropdownToggle").click();
      }
    },
    openArrivalDropDownMenuOnKeyDown() {
      if (this.$refs.fromToInputs && this.$refs.fromToInputs.$el) {
        const toDropdownMenu = this.$refs.fromToInputs.$el.querySelector(".toWhereDropdown.searchDropdown .dropdown-menu");
        if (toDropdownMenu) {
          const isDropdownOpen = $(toDropdownMenu).hasClass("show");
          if (!isDropdownOpen) {
            // Dropdown açık değilse
            const dropdownInput = this.$refs.fromToInputs.$el.querySelector(".toWhereDropdown.searchDropdown .dropdown-toggle");
            if (dropdownInput) {
              dropdownInput.click();
            }
          }
        }
      }
    },
    windowScreenWidth() {
      let screenWidth = window.innerWidth;
      // Check if the screen width is greater than 767px
      if (screenWidth < 767) {
        // departure dropdown
        $(".mobileDropdownFixed.whereFromDropdown .dropdown-toggle").click(function () {
          $(".mobileDropdownFixed.whereFromDropdown .searchDropdown").addClass("show");
          $(".mobileDropdownFixed.whereFromDropdown .mobileDropdown").dropdown("show");
        });
        // arrival dropdown
        $(".mobileDropdownFixed.toWhereDropdown .dropdown-toggle").click(function () {
          $(".mobileDropdownFixed.toWhereDropdown.searchDropdown").addClass("show");
          $(".mobileDropdownFixed.toWhereDropdown .mobileDropdown").dropdown("show");
        });
      }
    },
    closeDropdown() {
      setTimeout(() => {
        if (Object.keys(this.toStation).length > 0) {
          let toStationCityId = this.toStation.district?.city?.id > 0 ? this.toStation.district.city.id : this.toStation.areaCode;

          if (this.citiesMap && Object.keys(this.citiesMap).length > 0) {
            this.toStationFilterInput = this.toStation.name + " , " + this.citiesMap[toStationCityId].name;
          } else {
            this.toStationFilterInput = this.stationMap[this.toStation.id].name + " , " + this.citiesMap[toStationCityId].name;
          }
        }
        if (Object.keys(this.fromStation).length > 0) {
          let fromStationCityId = this.fromStation.district?.city?.id > 0 ? this.fromStation.district.city.id : this.fromStation.areaCode;

          if (this.citiesMap && Object.keys(this.citiesMap).length > 0) {
            this.fromStationFilterInput = this.fromStation.name + " , " + this.citiesMap[fromStationCityId].name;
          } else {
            this.fromStationFilterInput = this.stationMap[this.fromStation.id].name + " , " + this.citiesMap[fromStationCityId].name;
          }
        }
        $(".whereFromDropdown .mobileDropdown").dropdown("hide");
        $(".toWhereDropdown .mobileDropdown").dropdown("hide");
      });
    },
    closeDropdownPickUpTime() {
      setTimeout(() => {
        $(".carTimeArea #pickUpTime.whereFromDropdown .searchDropdown").dropdown("hide");
      });
    },
    closeDropdownDropOffTime() {
      setTimeout(() => {
        $(".carTimeArea #dropOffTime.whereFromDropdown .searchDropdown").dropdown("hide");
      });
    },
    mobileFocusDepartureInput() {
      // click olduktan sonra display:none olan dropdown açılıyor bu yüzden setTimeout.
      setTimeout(() => {
        if (window.innerWidth < 767) {
          // body scroll her zaman sıfırla
          window.scrollTo(0, 0);
          // Ardından 65px aşağıya kaydır (çarpı butonu yüksekliği kadar)
          setTimeout(() => {
            window.scrollTo(0, 65);
          });
        }
        this.$refs.departureInput.focus();
      });
    },
    mobileFocusFromCarInput() {
      // click olduktan sonra display:none olan dropdown açılıyor bu yüzden setTimeout.
      setTimeout(() => {
        this.$refs.fromCar.focus();
      });
    },
    mobileFocusWhereCarInput() {
      // click olduktan sonra display:none olan dropdown açılıyor bu yüzden setTimeout.
      setTimeout(() => {
        this.$refs.whereCar.focus();
      });
    },
    mobileFocusArrivalInput() {
      // click olduktan sonra display:none olan dropdown açılıyor bu yüzden setTimeout.
      setTimeout(() => {
        if (window.innerWidth < 767) {
          // body scroll her zaman sıfırla
          window.scrollTo(0, 0);
          // Ardından 65px aşağıya kaydır (çarpı butonu yüksekliği kadar)
          setTimeout(() => {
            window.scrollTo(0, 65);
          });
        }
        this.$refs.arrivalInput.focus();
      });
    },
    datePickerIsOpen(ref) {
      let dateRangePickerRef = ref === "multipleDateRangePickerStart" ? this.$refs[ref].$refs[this.dateRangePickerRef] : "multipleDateRangePickerStart";
      if (dateRangePickerRef.open === true) {
        dateRangePickerRef.togglePicker(null, true);
      }
    },
    setInputTo(validationActive) {
      this.$nextTick(() => {
        if (this.toStationFilterInput !== undefined) {
          if (this.toStationFilterInput.length !== 0) {
            if (Object.keys(this.toStation).length !== 0) {
              this.toStationFilterInput = this.toStation.name;
            }
          } else if (this.toStationFilterInput.length === 0) {
            // if (this.toStation.name) {
            //   this.toStationFilterInput = this.toStation.name;
            // }
            // this.toStation = {};
          } else {
            throw "Unexpected To Input length";
          }
        }
        if (validationActive) {
          this.checkToInputValidation();
        }
      });
    },
    setInputFrom(validationActive) {
      //Dropdown içerisinden bir item seçilen süre boyunca validation çalışmaması için koyuldu (OKK)
      if (this.fromStationFilterInput.length === 0) {
        Vue.set(this, "toStations", []);
      }
      this.$nextTick(() => {
        if (this.fromStationFilterInput.length !== 0) {
          if (Object.keys(this.fromStation).length !== 0) {
            this.fromStationFilterInput = this.fromStation.name;
          }
        } else if (this.fromStationFilterInput.length === 0) {
          Vue.set(this, "fromStation", {});
        } else {
          throw "Unexpected From Input length";
        }
        if (validationActive) {
          this.checkFromInputValidation();
        }
      });
    },
    setCarFromInput() {
      if (this.selectedTakePlaceInput.length !== 0) {
        if (Object.keys(this.selectedTakePlace).length !== 0) {
          this.selectedTakePlaceInput = this.selectedTakePlace.fullName;
        }
      } else if (this.selectedTakePlaceInput.length === 0) {
        this.selectedTakePlace = {};
      } else {
        throw "Unexpected From Input length";
      }
    },
    setCarWhereInput() {
      if (this.selectedDropPlaceInput.length !== 0) {
        if (Object.keys(this.selectedDropPlace).length !== 0) {
          this.selectedDropPlaceInput = this.selectedDropPlace.fullName;
        }
      } else if (this.selectedDropPlaceInput.length === 0) {
        this.selectedDropPlace = {};
      } else {
        throw "Unexpected Where Input length";
      }
    },
    checkFromInputValidation() {
      if (this.fromStation.name) {
        this.fromStationFilterInput = this.fromStation.name;
      }
      if (Object.keys(this.fromStation).length === 0) {
        const result = {
          errors: [this.$t("home-departure-stations-error")],
          valid: false,
          failedRules: {},
        };

        const targetRef = this.$refs.fromInputs || this.$refs.seferSearchTabRef.$refs.fromInputs;
        if (targetRef) {
          targetRef.applyResult(result);
        }

        return false;
      } else {
        return true;
      }
    },
    selectStation(istasyonId, way) {
      if (way === "to") {
        if (this.citiesMap && Object.keys(this.citiesMap).length > 0) {
          this.toStation = this.stationMap[istasyonId];
          let toStationCityId = this.toStation.district?.city?.id > 0 ? this.toStation.district.city.id : this.toStation.areaCode;
          this.toStationFilterInput = this.stationMap[istasyonId].name + " , " + this.citiesMap[toStationCityId].name;
        } else {
          this.toStation = this.stationMap[istasyonId];
          this.toStationFilterInput = this.stationMap[istasyonId].name;
        }
      } else if (way === "from") {
        if (this.citiesMap && Object.keys(this.citiesMap).length > 0) {
          this.fromStation = this.stationMap[istasyonId];

          let fromStationCityId = this.fromStation.district?.city?.id > 0 ? this.fromStation.district.city.id : this.fromStation.areaCode;

          this.fromStationFilterInput = this.stationMap[istasyonId].name + " , " + this.citiesMap[fromStationCityId].name;
        } else {
          this.fromStation = this.stationMap[istasyonId];
          this.fromStationFilterInput = this.stationMap[istasyonId].name;
        }

        let toStations_ = [];
        let toStationIds = this.fromStation.id;
        // pairleri al
        let toStationPairs = this.stationMap[toStationIds].pairs;
        //this.toStation = {};

        if (!toStationPairs) {
          alert(this.$t("from-to-mixin-arrival-station-not-found"));
          return;
        }
        for (let i = 0; i < toStationPairs.length; i++) {
          if (this.stationMap[toStationPairs[i]] === undefined) continue;
          toStations_.push(this.stationMap[toStationPairs[i]]);
        }
        this.toStations = toStations_;
        // pairleri almıyoruz
        // this.toStations = this.fromToStations;
      }
      // close dropdown
      this.closeDropdown();
    },
    selectTrainStation(istasyonId) {
      this.fromStation = this.stationMap[istasyonId];
      this.fromStationFilterInput = this.stationMap[istasyonId].name;
    },
    async selectCurrentLocation() {
      if (this.stations.length > 0 && navigator.geolocation) {
        navigator.geolocation.getCurrentPosition((position) => {
          this.currentLocationStation = this.stations[0];
          let selectedLatitude = Math.abs(this.stations[0].enlem - position.coords.latitude);
          let selectedLongitude = Math.abs(this.stations[0].boylam - position.coords.longitude);

          for (let i = 1; i < this.stations.length; i++) {
            let latitude = Math.abs(this.stations[i].enlem - position.coords.latitude);
            let longitude = Math.abs(this.stations[i].boylam - position.coords.longitude);

            if (latitude < selectedLatitude && longitude < selectedLongitude) {
              selectedLatitude = latitude;
              selectedLongitude = longitude;
              this.currentLocationStation = this.stations[i];
            }
          }
        });
      }
    },
    setSelectedCurrentStation() {
      if (this.currentLocationStation === null) return;
      this.fromStation = this.currentLocationStation;
      this.fromStationFilterInput = this.stationMap[this.currentLocationStation.istasyonId].name;
      this.selectStation(this.currentLocationStation.istasyonId, "from");
    },
    updateCitiesMap(cities) {
      this.citiesMap = cities.reduce((acc, city) => {
        acc[city.id] = city;
        return acc;
      }, {});
    },
  },
  mounted() {
    this.windowScreenWidth();
    this.formatSubmitDisabled();
  },
  watch: {
    fromStation: {
      //watch ile fromStation degisti mi kontrolu yapildi. Degistiyse toStation resetleniyor.
      //watch kullanılmasinin sebebi eski ve yeni değerin karşılaştırılmasını sağlamak
      handler(newValue, oldValue) {
        if (newValue === undefined || newValue.id === undefined || Object.keys(newValue).length === 0) return;
        if (newValue !== oldValue) {
          // this.toStations array'indeki objelerden birinin 'this.toStation' ile eşleşip eşleşmediğini kontrol et
          const stationMatch = this.toStations.some((station) => station.id === this.toStation.id);

          if (!stationMatch) {
            this.toStation = {};
            this.toStationFilterInput = "";
            this.selectStation(newValue.id, "from");
          }
        }
      },
    },
  },
};
